<template>
  <div class="main_mien">
    <div class="common_title">
      <p>
        <span class="title pointer" :class="{'title_act': cls === 5}" @click="cls = 5">教师风采</span>
        <span class="title pointer" :class="{'title_act': cls === 6}" @click="cls = 6">学校风采</span>
      </p>
      <span class="more pointer" @click="toList">更多</span>
    </div>
    <div class="main_mien_content">
      <ul>
        <li class="pointer" v-for="item in list" :key="item.id" @click="toDetail(item.id)">
          <el-image class="image" lazy :src="item.logo" fit="cover">
            <div slot="error" class="image_error">暂无图片</div>
          </el-image>
          <div class="list_info">
            <h3>{{ item.name }}</h3>
            <span v-if="item.title">{{ item.title }}</span>
            <p v-if="cls === 6" :class="{'school_content': !item.title}">{{ item.content }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mainMien',
  components: {},
  props: ['dxfc'],
  data () {
    return {
      cls: 5
    }
  },
  created () {
  },
  mounted () {
  },
  computed: {
    list () {
      return this.dxfc
    }
  },
  methods: {
    toList () {
      this.$router.push({
        path: this.cls === 5 ? '/mien/teacher' : '/mien/school'
      })
    },
    toDetail (itemId) {
      this.$router.push({
        path: this.cls === 5 ? '/mien/tDetail' : '/mien/sDetail',
        query: {
          itemId: itemId
        }
      })
    }
  },
  watch: {
    cls (cls) {
      this.$emit('onChangeCls', cls)
    }
  }
}
</script>

<style scoped>
  .main_mien { float: right; width: 380px; height: 510px; padding: 0 10px; border-radius: 2px; border: 1px solid #DCDFE6; }
  .main_mien .common_title > p > span {float: left;background-color: #FFFFFF;color: #999999;border-bottom: 1px solid #77B950;}
  .main_mien .common_title .title_act { background-color: #77B950; color: #FFFFFF; border-bottom: none; }
  .main_mien .main_mien_content { height: 459px; overflow: auto; }
  .main_mien .main_mien_content ul { padding: 10px 0; }
  .main_mien .main_mien_content ul li { height: 60px; margin-bottom: 10px; }
  .main_mien .main_mien_content ul li:last-child { margin-bottom: 0; }
  .main_mien .main_mien_content ul li .image { float: left; width: 60px; height: 60px; border-radius: 3px; }
  .main_mien .main_mien_content ul li .list_info { padding-top: 5px; margin-left: 70px; }
  .main_mien .main_mien_content ul li .list_info h3 { color: #333333; font-size: 14px; font-weight:600; line-height: 14px; margin-bottom: 5px; }
  .main_mien .main_mien_content ul li .list_info span { display: block; color: #999999; font-size: 12px; font-weight: 400; line-height: 14px; margin-bottom: 8px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
  .main_mien .main_mien_content ul li .list_info p { color: #666666; font-size: 12px; line-height: 16px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
  .main_mien .main_mien_content ul li .list_info p.school_content { -webkit-line-clamp: 2; }
  .main_mien .main_mien_content ul li:hover .list_info h3 { color: #76BF28; }
  .main_mien .main_mien_content ul li:hover .list_info span { color: #99C767; }
  .main_mien .main_mien_content ul li:hover .list_info p { color: #76BF28; }
</style>



// WEBPACK FOOTER //
// src/components/main/mien.vue